import { dataParaIso } from "./dataParaIso";

export function isBirthday(valor, hoje = new Date()) {
    const texto = dataParaIso(valor);
    if (!texto) return false;

    const [, mesTexto, diaTexto] = texto.split("-");
    const mes = Number(mesTexto);
    const dia = Number(diaTexto);
    const mesHoje = hoje.getMonth() + 1;
    const diaHoje = hoje.getDate();

    if (mes === mesHoje && dia === diaHoje) return true;

    const anoHoje = hoje.getFullYear();
    const bissexto = (anoHoje % 4 === 0 && anoHoje % 100 !== 0) || anoHoje % 400 === 0;
    return !bissexto && mes === 2 && dia === 29 && mesHoje === 2 && diaHoje === 28;
}
